/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  ModalDescription,
  Text,
  Space,
  Button,
  Conditional,
  RadioGroup,
} from '@cashfree-intl/coherent';
import CustomIcon from '../../../../components/CustomIcons';

import { STANDARD_PRICING_LINK } from '../../constants';
import EVENTS from '../../../../constants/analytics';
import Analytics from '../../../../utils/analytics';

const PaymentMethodsList = ({
  closeModal,
  paymentMethods,
  onEnable,
  selectedMode,
  resetSelectedMode,
  loading,
}) => {
  const [errorMessage, resetErrorMessage] = useState('');

  const onStandardPricingClick = () => {
    window.open(STANDARD_PRICING_LINK, '_blank');
    Analytics.track(
      EVENTS.PAYMENT_METHODS.ENABLE_PAYMENT_MODE_STANDARD_PRICING,
    );
  };

  const renderPaymentModes = list => {
    const radioOptions = list.map(mode => ({
      label: () => (
        <label>
          <Space direction="column" gap={1} alignItems="flex-start">
            <CustomIcon componentName={mode.nick.toUpperCase()} />
            <Conditional if={mode.activationTime}>
              <Text variant="b12" color="bodyLight">
                {mode.activationTime}
              </Text>
            </Conditional>
          </Space>
        </label>
      ),
      name: 'paymentMode',
      value: mode.code,
    }));

    const handleOptionalRadioOptions = obj => ({
      ...obj,
      checked: selectedMode === obj.value,
      onChange: () => {
        resetSelectedMode(obj.value);
        if (errorMessage) resetErrorMessage('');
      },
    });

    return (
      <RadioGroup
        fieldLabel=""
        radioOptions={radioOptions.map(handleOptionalRadioOptions)}
      />
    );
  };

  const renderPaymentGroup = () => (
    <div>
      {Object.keys(paymentMethods).map(key => (
        <div className="payment-group" key={key}>
          <Space direction="column" gap={1}>
            <Text variant="b14">{paymentMethods[key].displayText}</Text>
            <div className="payment-modes">
              {renderPaymentModes(paymentMethods[key].paymentModes)}
            </div>
          </Space>
        </div>
      ))}
    </div>
  );

  const onFormSubmit = () => {
    if (!selectedMode)
      resetErrorMessage('Select a payment mode you want to activate.');
    else onEnable();
  };

  const renderContent = () => (
    <div>
      {renderPaymentGroup()}
      <Conditional if={errorMessage}>
        <Text variant="b14" color="danger">
          {errorMessage}
        </Text>
      </Conditional>
      <div className="text-right cta-wrapper">
        <Button
          type="button"
          link
          className="link"
          onClick={closeModal}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          type="button"
          onClick={onFormSubmit}
          primary
          loading={loading}
          disabled={loading}
        >
          Continue
        </Button>
      </div>
    </div>
  );

  return (
    <>
      <ModalDescription>
        <Text variant="b14" color="bodyLight">
          Some of the payment methods require approval from respective payment
          providers and it will take time to get these enabled.{' '}
          <a onClick={onStandardPricingClick}>Standard pricing</a> will be
          applicable.
        </Text>
      </ModalDescription>
      {renderContent()}
    </>
  );
};

PaymentMethodsList.propTypes = {
  closeModal: PropTypes.func.isRequired,
  paymentMethods: PropTypes.object.isRequired,
  onEnable: PropTypes.func.isRequired,
  selectedMode: PropTypes.string.isRequired,
  resetSelectedMode: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default PaymentMethodsList;
